// extracted by mini-css-extract-plugin
export default {"fileDownloadLabels":"DownloadSelectedMediaButton_fileDownloadLabels__Na+1s","menuItem":"DownloadSelectedMediaButton_menuItem__N++tN"};